import React from 'react';
import type { InputBlockType } from '~/components/page/Forms/components/Builder/utils/isInputTypeBlock';
import BlockLayout from '../BlockLayout';
import LocalesInput from '../LocalesInput';
import { blockLabelMap } from '../../constants';

type Props = {
  onChange: (next: InputBlockType) => void;
  onDelete: () => void;
  nodeId: string;
  block: InputBlockType;
};

const InputForType: React.FCC<Props> = ({
  onChange,
  onDelete,
  nodeId,
  block,
}) => (
  <BlockLayout
    heading={blockLabelMap[block.__typename]}
    onDelete={onDelete}
    blockKey={block.key}
    nodeId={nodeId}
  >
    <LocalesInput
      block={block}
      onChange={onChange}
      subject="label"
      blockKey={block.key}
      nodeId={nodeId}
    />
  </BlockLayout>
);

export default InputForType;
